import { Link } from "react-router-dom";
import { animeCategories } from "@/mocks/anime";

export default function CategoryTabs() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">分类浏览</h2>
          <p className="text-sm text-foreground-600 mt-2">选择你喜欢的动漫类型，开始追番之旅</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {animeCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-white rounded-2xl p-6 md:p-8 text-center hover:bg-background-50 transition-colors cursor-pointer"
            >
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-primary-100 rounded-2xl group-hover:bg-primary-500 transition-colors">
                <i className={`${cat.icon} text-2xl text-primary-500 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-950 mb-2">{cat.name}</h3>
              <p className="text-xs text-foreground-500">
                {cat.slug === "japanese" && "热门日漫，每周更新"}
                {cat.slug === "korean" && "韩漫精选，下拉式阅读"}
                {cat.slug === "chinese" && "国漫崛起，精彩纷呈"}
                {cat.slug === "movie" && "剧场版动漫，大银幕体验"}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}